<template>
    <div>


      <v-dialog
          v-model="dialog_error"
          max-width="800"
          style
      >   <v-card class="pa-8">
          <v-icon class="text-h1" color="red">mdi-close</v-icon>
          <div class="text-h6 mt-4"><b>ไม่สามารถจองตอนนี้ได้</b></div>
          <div class="text-h7 mt-4">{{ error_text_1 }}</div>
          <div class="text-h7 mt-4">{{ error_text_2 }}</div>
          <div class="text-center mt-16">
              <v-btn outlined style="color:black" rounded color="grey" @click="dialog_error=false">
              <v-icon left>mdi-close</v-icon>ปิด</v-btn>
          </div>
          </v-card>
      </v-dialog>

      <div class="text-h5">
          <v-icon large>mdi-pencil-box-outline</v-icon> {{ $t('reservation_group_title') }}
      </div>
      <v-list 
        :rounded="true"
        class="mt-8">
        <v-list-item
            v-for="(item) in grouplist"
            :key="item.group_id"
            @click="selectgroup(item.group_id)"
            style="border: 4px solid #D7FF66;"
            :disabled="item.reserve_hold_by=='staff_only'"
            class="d-flex"
        >
          <div class="ma-2">{{ item.group_name }}</div>
          <v-icon class="ml-auto" v-if="item.reserve_hold_by!='staff_only'">mdi-chevron-right</v-icon>
        </v-list-item>
      </v-list>
    </div>
</template>


<script>

import axios from 'axios';
import config from '@/../config.js'
import AppointmentSelection from '@/models/instance/AppointmentSelection.js'
import App from '@/models/instance/App'

export default {
  props: ['nextstep'],
  data () {
    return {
      grouplist : [],
      error_text_1 : "",
      error_text_2 : "",
      dialog_error : false
    }
  },
  mounted : function () {
    var que = this.$store.commit('addLoading')
    axios
    .post(config.api.url.public.appointment.get_grouplist,{station_code:AppointmentSelection.getStationCode()})
    .then(response => {
      this.grouplist = response.data.grouplist
      if(this.$route.query.custompage!=undefined
            && config['custompage']!=undefined
            && config['custompage'][App.getAppId()]!=undefined
            && config['custompage'][App.getAppId()][this.$route.query.custompage]!=undefined 
            && config['custompage'][App.getAppId()][this.$route.query.custompage]['group_list']!=undefined){
          this.grouplist = this.grouplist.filter(g=>config['custompage'][App.getAppId()][this.$route.query.custompage]['group_list'].includes(g.group_id))
      }
      this.$store.commit('finishLoading',que)
    })
  },
  methods : {
    selectgroup(group_id){

      var is_enable = true

      var group = this.grouplist.filter(g=>g.group_id==group_id)[0]

      if(group.reserve_enable_startdate.length>0){
        var dstr_startdate = group.reserve_enable_startdate.split(' ')
        dstr_startdate = dstr_startdate[0] + 'T' + dstr_startdate[1] + ':00+0700'
        var startdate = new Date(dstr_startdate)
        if(startdate>new Date()){
          var th_weekdays = ['อาทิตย์','จันทร์','อังคาร','พุธ','พฤหัสบดี','ศุกร์','เสาร์']
          var th_month = ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม']    
          this.dialog_error = true
          this.error_text_1 = "บริการนี้จะเปิดให้เริ่มจองใน"
          this.error_text_2 = "วัน" + th_weekdays[startdate.getDay()] + "ที่ " + startdate.getDate() + " " + th_month[startdate.getMonth()] + " " + (startdate.getFullYear()+543) + " เวลา " + group.reserve_enable_startdate.split(' ')[1] + "น." 
          is_enable = false
        }
      }

      if(group.reserve_enable_enddate.length>0){
        var dstr_enddate = group.reserve_enable_enddate.split(' ')
        dstr_enddate = dstr_enddate[0] + 'T' + dstr_enddate[1] + ':00+0700'
        if(new Date(dstr_enddate)<new Date()){
          this.dialog_error = true
          this.error_text_1 = "บริการนี้ได้ปิดรับจองแล้ว"
          this.error_text_2 = "ขออภัยในความไม่สะดวก"
          is_enable = false
        }
      }

      if(is_enable){
        AppointmentSelection.setGroupId(group_id)
        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.public.appointment.get_groupextranotelist,{group_id:group_id})
        .then(response => {
          AppointmentSelection.setExtranote(JSON.stringify(response.data))
          this.$store.commit('finishLoading',que)
          this.nextstep()
        })
      }
    }
  },
}
</script>